import { render, staticRenderFns } from "./ed-response-type-object.vue?vue&type=template&id=8201b548&scoped=true&"
import script from "./ed-response-type-object.ts?vue&type=script&lang=ts&"
export * from "./ed-response-type-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-response-type-object.scss?vue&type=style&index=0&id=8201b548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8201b548",
  null
  
)

export default component.exports